import { useCallback, useEffect, useState } from 'react'

import { flightTeamServices } from '../services/flightTeamServices';

import useErrorHandler from './useErrorHandler';

function useFlightTeam(filters = {}, dependency = []) {
    const { errorHandler } = useErrorHandler();

    const [flightTeamList, setFlightTeamList] = useState([]);
    const [rowCount, setRowCount] = useState(0);

    const getAllFlightTeam = useCallback(async (currentFilters) => {
        try {
            const res = await flightTeamServices.getAllFlightTeam(currentFilters);
            console.log("getAllFlightTeam => ", res);
            if (res.status === 200) {
                setFlightTeamList(res.data.data);
                setRowCount(res.data.rowCount);
            }
        } catch (error) {
            console.log(error);
            errorHandler('error: getAllFlightTeam', error.response.status);
        }
    }, []);

    useEffect(() => {
        getAllFlightTeam(filters);
    }, dependency);

    return { flightTeamList, rowCount };
}

export default useFlightTeam